import React, { useEffect, useRef, useState } from 'react';
import { ConnectionCheckListener } from 'core/infrastructure';
import { Res } from 'core/api';
import { Modal } from './modal';
import { DialogBody, DialogFooter, Link, ProgressCircle, VStack, Text, Box } from '@chakra-ui/react';

let currentDialog: {
	close: () => void;
	nextAction: 'abort' | 'retry';
} | null = null;

const RetryConnectionDialog: React.FC<Modal.Actions<void>> = ({ close }) => {
	const [nextAction, setNextAction] = useState<'abort' | 'retry'>('retry');
	const [elapsedTime, setElapsedTime] = useState(0);
	const startMs = useRef(Date.now());
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		currentDialog = { close, nextAction };

		timerRef.current = setInterval(() => {
			setElapsedTime(Math.floor((Date.now() - startMs.current) / 1000));
		}, 1000);

		return () => {
			currentDialog = null;
			if (timerRef.current) clearInterval(timerRef.current);
		};
	}, [nextAction, close]);

	return (
		<Box bg={{ base: 'white', _dark: '{colors.gray.800}' }}>
			<DialogBody>
				<VStack>
					<Text>{Res.Msg.MSG_CONNECTING_TO_SERVER()}</Text>
					<Text fontSize={'sm'} fontWeight={'light'}>
						{elapsedTime}s
					</Text>
					<ProgressCircle.Root value={null} size="sm">
						<ProgressCircle.Circle>
							<ProgressCircle.Track />
							<ProgressCircle.Range stroke={'yellow.500'} strokeLinecap={'round'} />
						</ProgressCircle.Circle>
					</ProgressCircle.Root>
				</VStack>
			</DialogBody>
			<DialogFooter>
				<Link variant="underline" onClick={() => setNextAction('abort')}>
					{Res.Common.CANCEL_BTN()}
				</Link>
			</DialogFooter>
		</Box>
	);
};

// Listener de conexión
export const connectionCheckListener: ConnectionCheckListener = {
	onCheckCompleted: () => currentDialog?.close(),
	onConnectionFailed: async () => {

		if (currentDialog) {
			return currentDialog.nextAction;
		}

		void Modal.show(RetryConnectionDialog, { placement: 'top', size: 'sm', closeOnInteractOutside: false });

		// Esperar hasta que el diálogo se muestre
		const check = (resolve: (value: 'retry' | 'abort') => void) => {
			if (currentDialog) {
				resolve(currentDialog.nextAction);
			} else {
				setTimeout(() => check(resolve), 10);
			}
		};

		return new Promise(resolve => {
			check(resolve);
		});
	},
};

export default RetryConnectionDialog;
